import React from 'react';

import Typography from '@material-ui/core/Typography';

import IntlMessageComponent from 'components/formatters/intlMessage';
import PageSubTitleViewComponent from 'components/pageTitle/subTitle';


export default function ScfDebtorWaitingListSuccessComponent() {
  return (
    <React.Fragment>

      <PageSubTitleViewComponent id="page.scfDebtorWaitingList.h1" />

      <Typography variant="body1">
        <IntlMessageComponent id="page.scfDebtorWaitingList.success" />
      </Typography>

    </React.Fragment>
  );
}
